import { HttpError } from 'ra-core'
import { fetchUtils } from 'react-admin'

import env from '../config/env'

// Bypass Firebase when performing MyMove API calls.
// The backend server must be configured to allow authentication bypass.

export default () => {
  return async (url, { rawResponse, ...options } = {}) => {
    let token = env.LOCAL_TOKEN_OVERRIDE
    if (!token) {
      throw new Error('Token undefined in local development mode')
    }

    options.user = {
      authenticated: true,
      token: `Bearer ${token}`,
    }

    if (rawResponse) {
      const response = await fetch(url, options)

      if (!response.ok) {
        let body
        try {
          body = await response.json()
        } catch {
          body = undefined
        }

        throw new HttpError(response.statusText || 'Request failed', response.status, body)
      }

      return response
    }

    return fetchUtils.fetchJson(url, options)
  }
}
